import {gql} from '@apollo/client'
import React from 'react'
import PropTypes from 'prop-types'
import {Query as ApolloQuery} from '@apollo/client/react/components'
import {Field} from 'redux-form'
import withCacheClient from '@cred/shared/hoc/withCacheClient'
import LogService from '../../services/logService'
import NotFoundDisclosure from '../../components/not-found-disclosure'
import {withApollo} from '@apollo/client/react/hoc'

const Query = withCacheClient(ApolloQuery),
  requiredFn = () => 'Waiting for disclosure',
  DISCLOSURE_QUERY = gql`
    query($slug: String!) {
      disclosure(slug: $slug) {
        slug
        uuid
        id
        name
        contentType
        htmlContent
        label
        url
        meta {
          key
          value
        }
        variables {
          slug
        }
        children {
          slug
          name
          contentType
        }
      }
    }
  `,
  getHandler = props => ({loading, error, data}) => {
    const {children, loading: renderLoading, name, required, client} = props

    if (error) {
      LogService.error(
        client,
        `[Disclosures SDK] Error getting the disclosure: ${error}`
      )

      if (required) {
        return (
          <Field name={name} validate={requiredFn} component={NotFoundDisclosure}/>
        )
      }

      return <NotFoundDisclosure/>
    }

    if (loading) {
      if (required) {
        return (
          <Field name={name} validate={requiredFn} component={renderLoading}/>
        )
      }

      return null
    }

    if (data) {
      return children(data.disclosure)
    }
  },
  DisclosureQuery = props => {
    const {slug} = props,
      handler = getHandler(props)

    return (
      <Query query={DISCLOSURE_QUERY} variables={{slug}}>
        {handler}
      </Query>
    )
  }

DisclosureQuery.propTypes = {
  slug: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  required: PropTypes.bool,
  loading: PropTypes.func
}
DisclosureQuery.defaultProps = {
  loading: () => null,
  required: true
}

export {DISCLOSURE_QUERY, DisclosureQuery as DisclosureQueryNoHOCs, getHandler}
export default withApollo(DisclosureQuery)
